import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";

export default function StickyCta() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <a
      href="#kontakt"
      data-testid="sticky-cta"
      className={`fixed bottom-5 right-5 lg:hidden z-40 inline-flex items-center gap-2 rounded-full bg-terra text-white px-5 py-3.5 text-sm font-medium shadow-hover transition-all duration-300 ${
        show ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
      }`}
    >
      Beratung sichern
      <ArrowRight className="h-4 w-4" strokeWidth={1.5} />
    </a>
  );
}
